/**
 * Agency rating constants for SEO and social proof
 * Source: Reco.se - Sweden's leading real estate review platform
 * 
 * These ratings are used across the site for:
 * - Meta descriptions
 * - Structured data (JSON-LD)
 * - Social proof messaging
 */

export const AGENCY_NAME = 'Erik Olsson Fastighetsförmedling';

export const AGENCY_RATING = {
  /** Rating value (e.g., 4.6 out of 5) */
  value: '4.9',
  /** Maximum rating scale */
  scale: '5',
  /** Total number of reviews (for structured data) */
  count: '35035',
  /** Display-friendly review count for descriptions (formatted with space) */
  displayCount: '35 035+',
  /** Source platform for the ratings */
  source: 'hittamaklare.se',
} as const;

/**
 * Get formatted rating string for meta descriptions
 * @example "4.7/5 i betyg (8 000+ omdömen)"
 */
export function getFormattedRating(): string {
  return `${AGENCY_RATING.value}/${AGENCY_RATING.scale} i betyg (${AGENCY_RATING.displayCount} omdömen)`;
}
